import { createBrowserRouter, Navigate } from "react-router-dom";
import { AdminLayout } from "@/components/admin/AdminLayout";

import LoginPage from "@/pages/auth/login/page";
import DashboardPage from "@/pages/admin/page";
import AdsPage from "@/pages/admin/ads/page";
import AnalyticsPage from "@/pages/admin/analytics/page";
import AudioPage from "@/pages/admin/audio/page";
import MediaPage from "@/pages/admin/media/page";
import FinancePage from "@/pages/admin/finance/page";
import ModerationPage from "@/pages/admin/moderation/page";
import PaymentsPage from "@/pages/admin/payments/page";
import ProposalsPage from "@/pages/admin/proposals/page";
import ProposalDetailPage from "@/pages/admin/proposals/[id]/page";
import TemplatesPage from "@/pages/admin/templates/page";
import TemplateDetailPage from "@/pages/admin/templates/[id]/page";
import TransitionsAdminPage from "@/pages/admin/transitions/page";
import UsersPage from "@/pages/admin/users/page";
import AiModelPricingPage from "@/pages/admin/ai-model-pricing/page";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    path: "/",
    element: <AdminLayout />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "ads", element: <AdsPage /> },
      { path: "analytics", element: <AnalyticsPage /> },
      { path: "audio", element: <AudioPage /> },
      { path: "media", element: <MediaPage /> },
      { path: "finance", element: <FinancePage /> },
      { path: "moderation", element: <ModerationPage /> },
      { path: "payments", element: <PaymentsPage /> },
      { path: "proposals", element: <ProposalsPage /> },
      { path: "proposals/:id", element: <ProposalDetailPage /> },
      { path: "templates", element: <TemplatesPage /> },
      { path: "templates/:id", element: <TemplateDetailPage /> },
      { path: "transitions", element: <TransitionsAdminPage /> },
      { path: "users", element: <UsersPage /> },
      { path: "ai-model-pricing", element: <AiModelPricingPage /> },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);